import React from 'react';
import Main from "./Main";
import {Grid} from "react-bootstrap";

import InfoBox from "./info-box/InfoBox";

require('dotenv').config();

const App = () => (
    <div className="app">
        <Grid>
            <Main/>
            <InfoBox/>
        </Grid>
    </div>
);

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js